<template>
    <div :class="{ 'content mb-0': !this.p2p }" class="flex-grow-1 h-100 d-flex flex-column">
        <div v-if='this.indexes || this.head_slot'
            class="d-flex container-fluid p-0 justify-content-end"
            :class="{
                'border-b': !this.filterPanel || this.filterPanel && !this.isMobile,
                'gap-3': this.isMobile, 
                'justify-content-between': this.head_slot, 
                'justify-content-end': !this.head_slot, 
                'p16 flex-column': this.isMobile, 
                'px24 py12 align-items-center': !this.isMobile,
                'flex-column-reverse': this.headReverse && this.isMobile
            }"
        >
            <div v-if="this.head_slot && !this.filterPanel" class="flex-grow-1">
                <slot name="head"></slot>
            </div>
            <div class="d-flex align-items-center" 
                :class="{'col-12': this.isMobile, 'mt16': this.isMobile && !this.filterPanel, 'w-100': this.filterPanel}"
            >
                <div class="d-flex align-items-center"
                    :class="{'flex-row-reverse flex-grow-1': this.isMobile,
                        'w-100 justify-content-between': this.filterPanel,
                    }"
                >
                    <div v-if="this.filterPanel && !this.isMobile" class="col-8">
                        <slot name="filterPanel"></slot>
                    </div>
                    <div v-if="this.btnFilter">
                        <slot name="filter"></slot>
                    </div>
                    <div v-if='this.indexes' class="align-items-center"
                        :class="{'col-sm-8 col-md-6': !this.head_slot, 'w296': !this.isMobile, 'w-100': this.isMobile}"
                    >
                        <InputSimple :id="'search_string'" class="h40" :icon="'search-grey'" :dataValue="this.search_string" :placeholder="$t('components.service.TableList.1') + '...'" @updateParentState="this.setValue">
                            <div v-if="this.search_string" @click="this.clearSearch" style="cursor: pointer;">
                                <Icon name="clear-search" class="c16 d-flex justify-content-center align-items-center" />
                            </div>
                        </InputSimple>
                    </div>
                </div>
                <Button 
                    v-if="this.btnRefresh && !this.isMobile"
                    @click="this.refresh()"
                    @mouseover="iconHover = 'refresh'"
                    @mouseleave="iconHover = false" 
                    type='btn-outline-warning'
                    class="h40 w40 ml8"
                >
                    <Icon name="refresh" size="c20" :active="iconHover === 'refresh'" />
                </Button>
                <Button 
                    v-if="this.btnChoiseColumns && !this.isMobile"
                    @click="this.choiseColumns()"
                    @mouseover="iconHover = 'table'"
                    @mouseleave="iconHover = false" 
                    type='btn-outline-grey'
                    class="h40 w40 ml8"
                >
                    <Icon name="table" size="c20" :active="iconHover === 'table'" />
                </Button>
                <Button 
                    v-if="this.btnFullTable && !this.isMobile"
                    @click="this.toggleContainer()"
                    @mouseover="iconHover = 'full-table'"
                    @mouseleave="iconHover = false" 
                    type='btn-outline-grey'
                    class="h40 w40 ml8"
                >
                    <Icon name="full-table" size="c20" :active="iconHover === 'full-table'" />
                </Button>
            </div>
        </div>
        <div v-if="isMobile">
            <slot name="filterData"></slot>
        </div>
        <div :class="{ 'border-b': this.d.length !== 0 && !this.isMobile, 'flex-grow-1': this.d.length == 0 }">
            <slot name="table"></slot>
        </div>
        <slot name="buttons"></slot>
        <div class="d-flex container-fluid g-3 align-items-center justify-content-between col-12 p-0">
            <Pagination :data.sync='this.d' :max="this.max" :savePage="this.savePage" @updateContentState="this.updateContent"/>
        </div>
    </div>
</template>
 
<script>
import Pagination from '@/components/service/pagination/Pagination';
import InputSimple from '@/components/service/InputSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon.vue';
import Button from '@/components/service/Button';

export default {
    components: {
        Pagination,
        InputSimple,
        Tooltip,
        Icon,
        Button
    },
    props: {
        data: [Array],
        max: {
            type: [Number, Boolean],
            default: 6,
        },
        savePage: {
            default: true,
            type: [Boolean],
        },
        paginationClass: {
            type: [String, Boolean],
        },
        sortRule: {
            type: [Object, Boolean],
        },
        indexes: [Array, Boolean],
        colNames: [Array, Boolean],
        initialData: [Array, Boolean],
        disabledColumns: [Array, Boolean],
        localStorageName: [String, Boolean],
        filterPanel: [Boolean],
        btnFullTable: [Boolean],
        btnChoiseColumns: [Boolean],
        btnRefresh: [Boolean],
        refresh: [Function],
        btnFilter: [Boolean],
        colSubs: [Array, Boolean],
        initialColSubs: [Array, Boolean],
        head_slot: [Boolean],
        headReverse: [Boolean],
        notRemove: {
            default: false,
            type: [Boolean, String],
        },
        sortOnDataUpdate: {
            default: true,
            type: [Boolean],
        },
        p2p: {
            default: false,
            type: [Boolean],
        },
        p2pMode: {
            default: false,
            type: [Boolean],
        },
    },
    watch: {
        data: {
            handler: function(newData, oldData) {
                if(this.sortOnDataUpdate) {
                    this.d = this.$lib.sortArr(newData.map(item => item), this.sortRule);
                }
                if (this.savePage) {
                    const searchObject = {
                        id: 'search_string',
                        value: this.search_string,
                    }
                    
                    this.setValue(searchObject);
                }
            },
            deep: true,
        },
        sortRule() {
            this.d = this.$lib.sortArr(this.d, this.sortRule);
        },
    },
    data() {
        return {
            d: this.$lib.sortArr(this.data.map(item => item), this.sortRule),
            search_string: '',
            iconHover: false,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    created() {
        console.log('sort_rule', this.sortRule);
    },
    mounted() {

    },
    methods: {
        toggleContainer() {
            this.$emit('toggleContainer');
        },
        updateContent(arg) {
            this.$emit('updateContentState', arg);
        },
        setValue(arg) { 
            if (this.indexes && arg.value != '') {
                let ar = [];
                this.data.forEach(e => {
                    for(let i = 0; i < this.indexes.length; i++) {
                        let reg = new RegExp(`${arg.value.toLowerCase()}`, 'i');

                        if (reg.test(e[this.indexes[i]]?.toLowerCase())) {
                            ar.push(e);
                            i = this.indexes.length;
                        }
                    }
                })
                this.d = this.$lib.sortArr(ar, this.sortRule);
            } else if(!arg.value && this.search_string) {
                this.d = this.$lib.sortArr(this.data.map(item => item), this.sortRule);
            }
            this[arg.id] = arg.value;
        },
        dSort(ind, type) {
            if (this.sortRule.ind === ind ) {
                this.sortRule.to = !this.sortRule.to;
            } else {
                this.sortRule.ind = ind;
                this.sortRule.to = true;
                this.sortRule.type = type;
            }

            this.d = this.$lib.sortArr(this.d, this.sortRule);
        },
        choiseColumns() {
            this.$store.commit('MODAL', {
                    action: true,
                    type: 'ChoiseColumns',
                    content: {
                        columns: this.colSubs ? this.colSubs : this.colNames,
                        disabledColumns: this.disabledColumns,
                        initialColumns: this.initialColSubs,
                        updateColumns: (columns) => {
                            const colNamesFilter = columns.filter(item => item.value == true);
                            const filteredData = this.$lib.getFilteredData(columns, this.initialData, this.notRemove);

                            window.localStorage.setItem(this.localStorageName, JSON.stringify(columns));

                            this.$emit('updateColumns', {
                                colNames: columns,
                                colSubs: columns,
                                colNamesFilter: colNamesFilter,
                                colSubsFilter: colNamesFilter,
                                filteredData: filteredData
                            });
                        },
                        reset: () => {
                            this.$emit('resetTable');
                        },
                        title: this.$t('components.service.TableList.3'),
                        width: 608
                    },
                }
            );
        },
        forceSort() {
            this.d = this.$lib.sortArr(this.data.map(item => item), this.sortRule);
        },
        clearSearch() {
            this.search_string = '';
            this.d = this.$lib.sortArr(this.data.map(item => item), this.sortRule);
        },
    }
}
</script>
<style lang="scss" scoped>
.p-mob {
    padding: 20px;
}
.w296 {
    width: 296px;
}
</style>